function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M113.004 35.5824C114.123 34.4095 115.936 34.4095 117.054 35.5824C118.172 36.7553 118.172 38.6568 117.054 39.8297L41.3015 119.28C40.1832 120.453 38.3702 120.453 37.2519 119.28C36.1336 118.107 36.1336 116.206 37.2519 115.033L113.004 35.5824Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M113.137 53.3763C114.255 52.2035 116.068 52.2035 117.186 53.3763C118.305 54.5492 118.305 56.4508 117.186 57.6236L58.2796 119.406C57.1613 120.579 55.3483 120.579 54.23 119.406C53.1117 118.233 53.1117 116.332 54.23 115.159L113.137 53.3763Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.1244 97.2334L96.0313 35.451C97.1496 34.2782 98.9627 34.2782 100.081 35.451C101.199 36.6239 101.199 38.5255 100.081 39.6983L41.174 101.481C40.0558 102.654 38.2427 102.654 37.1244 101.481C36.0061 100.308 36.0061 98.4063 37.1244 97.2334Z",
  fill: "white"
});

var SvgCbLogoRound = function SvgCbLogoRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M77 153C118.974 153 153 118.974 153 77C153 35.0264 118.974 1 77 1C35.0264 1 1 35.0264 1 77C1 118.974 35.0264 153 77 153Z",
    style: {
      stroke: "var(--color-primary)"
    },
    strokeWidth: 2
  }), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCbLogoRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cb-logo-round.8a04bf6f.svg";
export { ForwardRef as ReactComponent };